import React, { useEffect, useState} from 'react';
import queryString from 'query-string';
import BackHeader from '@comp/BackHeader/index';
import StartPng from '@/assets/icons/start.png';
import LogoPng from '@/assets/icons/logo.png';
import {getEnv} from '@utils/tools';
import {registDetail} from '@/store/api/deal';

import './index.less';

export default function (props) {
  let {i} = queryString.parse(props.location.search);
  //i=18139432_11251_10264112514_111 i=deal_id -- doctor_id -- mis_doctor_id --user_id//解决部分手机短信&符号问题, 2018年8月9日16:21:56
  let arr = i.split('_');
  const deal_id = arr[0],
    doctor_id = arr[1],
    mis_doctor_id = arr[2],
    user_id = arr[3];
  const str = queryString.stringify({deal_id, doctor_id, mis_doctor_id, user_id});

  const [showHeader, setShowHeader] = useState(false);
  const [deal, setDeal] = useState({});
  const onStart = () => {
    console.log(props);
    props.history.replace('/comment/index?' + str);
  };
  const onEnd = () => {
    if (deal.comment_state == 2) {
      props.history.replace('/comment/detail?' + str);
      return;
    }
  };
  useEffect(()=>{
    getEnv(res => {
      if (res == 'miniprogram') {
        setShowHeader(false);
      } else if (res == 'iOSApp') {
        setShowHeader(false);
      } else if (res == 'androidApp') {
        setShowHeader(false);
      } else if (res == 'h5') {
        setShowHeader(true);
      } else {
        setShowHeader(true);
      }
    });
    queryDeal()
  }, [])
  const queryDeal = async () => {
    const res = await registDetail({
      deal_id,
      user_id,
    });
    if (res.code == 200) {
      setDeal(res.data);
      if (res.data.comment_state == 2) {
        props.history.replace('/comment/detail?' + str);
      }
      console.log(res)
    } else {
      // Toast.fail(`获取订单信息失败`);
    }
    
  };
  return (
    <section className="cmt-start">
      {showHeader && <BackHeader title={'固生堂就医评价'} />}
      {
        deal.comment_state == 1 ? (
          <div className="main">
            <img src={StartPng} alt="" className="start-png" />
            <div className="cnt">
              <div className="start" onClick={onStart}>
                进入评价
              </div>
              <img src={LogoPng} alt="" className="logo" />
            </div>
          </div>
        ) : deal.comment_state == 2 ? (
          <div className="cnt">
            <div className="start" onClick={onEnd}>
             查看评价
            </div>
            <img src={LogoPng} alt="" className="logo" />
          </div>
        ) : (
          <div className="cnt">
            <div className="start">
              当前订单无法评价
            </div>
            <img src={LogoPng} alt="" className="logo" />
          </div>
        )
      }
    </section>
  );
}
